var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowPrev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 8.95431 31.0457 0 20 0V0C8.95431 0 0 8.95431 0 20V20C0 31.0457 8.95431 40 20 40V40C31.0457 40 40 31.0457 40 20V20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2725 26.3821C22.9254 26.7292 22.3658 26.7292 22.0187 26.3821L16.1325 20.4959C15.8562 20.2196 15.8562 19.7734 16.1325 19.4971L22.0187 13.6109C22.3658 13.2638 22.9254 13.2638 23.2725 13.6109C23.6196 13.958 23.6196 14.5176 23.2725 14.8646L18.1442 20.0001L23.2796 25.1355C23.6196 25.4755 23.6196 26.0421 23.2725 26.3821Z",
    fill: "#107DEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 39C30.4934 39 39 30.4934 39 20H41C41 31.598 31.598 41 20 41V39ZM1 20C1 30.4934 9.50659 39 20 39V41C8.40202 41 -1 31.598 -1 20H1ZM20 1C9.50659 1 1 9.50659 1 20H-1C-1 8.40202 8.40202 -1 20 -1V1ZM20 -1C31.598 -1 41 8.40202 41 20H39C39 9.50659 30.4934 1 20 1V-1Z",
    fill: "#6BB3FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPrev);
export default __webpack_public_path__ + "static/media/arrow-prev.650f86d72d438e0cd4757fb9ff157853.svg";
export { ForwardRef as ReactComponent };